export const contactWithEmailRequiredMessage = 'Please select a contact with an email address.';
export const contactWithPhoneRequiredMessage = 'Please select a contact with a phone number.';
